import { gettext } from "web/script/modules/django-i18n";
import PropTypes from "prop-types";
import React from "react";
import Button from "../button/button";
import styles from "./marketing-agreement.css";
import SVGIcon from "../svg-icon/svg-icon";


export function MarketingAgreement({onSubmit, onNoOptionClick}) {
    return (
        <div className={styles.box}>
            <form className={styles.boxContent} onSubmit={onSubmit}>
                <div className={styles.cta}>
                    <div className={styles.ctaIcon}>
                        <span className={styles.ctaIconAlert}>
                            <SVGIcon name="bell" />
                        </span>
                        <span className={styles.ctaIconAlertNew}>
                            <span className={styles.ctaIconAlertNewText}>
                                {gettext("account.register.two-step.save_for_later_new_label")}
                            </span>
                            <SVGIcon name="alert-new" />
                        </span>
                    </div>
                    <div className={styles.ctaText}>
                        {gettext("account.register.two-step.save_for_later_screen_2_title")}
                    </div>
                    <Button styleType="tertiary" className={styles.ctaButton} type="submit" fullWidth>
                        {gettext("account.register.two-step.save_for_later_btn_yes_keep_updated")}
                    </Button>
                </div>
            </form>
            <a className={styles.ctaTextSmall} onClick={onNoOptionClick}>
                {gettext("account.register.two-step.save_for_later_link_text_no_updated")}
            </a>
        </div>
    );
}

export default MarketingAgreement;

MarketingAgreement.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onNoOptionClick: PropTypes.func.isRequired
};
